<template>
  <div class="mandala-display-wrapper md:col-span-5 lg:col-span-7 relative min-h-[140px] md:min-h-[400px]" id="mandala-display">
    <img
      v-if="b64image"
      :src="'data:image/jpeg;base64,' + b64image"
      class="w-full max-w-full rounded-lg shadow-md mx-auto"
      :style="{
        maxHeight: 'calc(100vh - 180px)',
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block'
      }"
      alt="Ваша мандала"
    />
    <div v-else class="mandala-placeholder md:p-8 p-3">
      <div class="mandala-placeholder-icon text-xl md:text-3xl">🔮</div>
      <h3 class="text-base md:text-xl font-medium text-gray-700 mb-1 md:mb-4">{{ $t('message.createYourMandala') }}</h3>

      <!-- Instructions: visible on desktop only -->
      <div v-if="currentStep === 1" class="max-w-md hidden md:block">
        <div class="instruction-step">
          <h4 class="font-medium mb-2">{{ $t('message.step1Title') }}</h4>
          <p class="help-text">{{ $t('message.step1Description') }}</p>
        </div>
        <div class="instruction-step instruction-step-active">
          <h4 class="font-medium mb-2">{{ $t('message.step2Title') }}</h4>
          <p class="help-text">{{ $t('message.step2Description') }}</p>
        </div>
        <div class="instruction-step">
          <h4 class="font-medium mb-2">{{ $t('message.step3Title') }}</h4>
          <p class="help-text">{{ $t('message.step3Description') }}</p>
        </div>
      </div>

      <div v-else-if="currentStep === 2" class="max-w-md hidden md:block">
        <div class="instruction-step">
          <h4 class="font-medium mb-2">{{ $t('message.step1Title') }}</h4>
          <p class="help-text">{{ $t('message.step1Complete') }}</p>
        </div>
        <div class="instruction-step instruction-step-active">
          <h4 class="font-medium mb-2">{{ $t('message.step2Title') }}</h4>
          <p class="help-text">{{ $t('message.step2Active') }}</p>
        </div>
        <div class="instruction-step">
          <h4 class="font-medium mb-2">{{ $t('message.step3Title') }}</h4>
          <p class="help-text">{{ $t('message.step3Description') }}</p>
        </div>
      </div>

      <!-- Help button for all instruction views -->
      <button @click="$emit('open-help-modal')"
        class="mt-2 md:mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700">
        <QuestionMarkCircleIcon class="h-5 w-5 mr-2" />
        {{ $t('message.needHelp') }}
      </button>
    </div>
  </div>
</template>

<script>
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'MandalaDisplay',
  components: {
    QuestionMarkCircleIcon
  },
  props: {
    b64image: String,
    currentStep: Number
  }
}
</script>
